import { api } from './api-client';

export interface CreditsInfo {
  creditsBalance: number;
  subscriptionStatus: 'none' | 'trial' | 'trial_expired' | 'active' | 'expired' | 'cancelled';
  trialEndDate: string | null;
  daysRemaining: number | null;
}

export interface CanScanResponse {
  canScan: boolean;
  reason?: string;
  creditsRemaining: number;
}

class CreditsService {
  /**
   * Get current user's credit balance and subscription info
   */
  async getCredits(signal?: AbortSignal): Promise<CreditsInfo> {
    return api.get<CreditsInfo>('/users/me/credits', { signal });
  }

  /**
   * Check if user can perform a scan (has credits/valid subscription)
   */
  async checkCanScan(signal?: AbortSignal): Promise<CanScanResponse> {
    return api.get<CanScanResponse>('/credits/check', { signal });
  }
}

export const creditsService = new CreditsService();
